import { render, staticRenderFns } from "./CardUnit2.vue?vue&type=template&id=04d12e47&scoped=true&"
import script from "./CardUnit2.vue?vue&type=script&lang=js&"
export * from "./CardUnit2.vue?vue&type=script&lang=js&"
import style0 from "./CardUnit2.vue?vue&type=style&index=0&id=04d12e47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d12e47",
  null
  
)

export default component.exports